import React from 'react'
import Price from '../Price/Price'
import PriceDynamicCreditCopy from '../PriceDynamicCreditCopy/PriceDynamicCreditCopy'

import * as Styled from './PriceContainer.styles'

const PriceContainer = ({ priceAttributes, creditPlansV5, ShowPaypalCreditOption, PAYPAL_IFC_MESSAGING }) => {
  return (
    <Styled.PriceContainer>
      <Price {...priceAttributes} ShowPaypalCreditOption={ShowPaypalCreditOption} creditPlansV5={creditPlansV5} />
      {PAYPAL_IFC_MESSAGING && (
        <PriceDynamicCreditCopy creditPlansV5={creditPlansV5} ShowPaypalCreditOption={ShowPaypalCreditOption} />
      )}
    </Styled.PriceContainer>
  )
}

export default PriceContainer
